
















import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxTabs } from 'devextreme-vue';

@Component({
  components: {
    DxTabs,
  },
})
export default class PurchaseNavigation extends Vue {
    private navIndex: number = 0;
    private initialised: boolean = false;

    private mounted() {
        switch (this.$route.name) {
            case 'ordersOverview':
                this.navIndex = 0;
                break;
            case 'externalInvoicesOverview':
                this.navIndex = 1;
                break;
        }

        setTimeout(() => {
            this.initialised = true;
        }, 150);
    }

    get navbarItems() {
        const self = this;
        return [
            { icon: 'fas fa-file', text: 'Bestellingen'},
            { icon: 'fas fa-file-invoice', text: 'Aankoopfacturen'},
        ];
    }

    @Watch('navIndex')
    private onNavIndexChanged(value: number, oldValue: number) {
        if (value === -1) {
            setTimeout(() => {
                this.navIndex = 0;
            }, 150);
        } else {
            if (this.initialised) {
                switch (value) {
                    case 0:
                        this.$router.push({ path: `/orders` });
                        break;
                    case 1:
                        this.$router.push({ path: `/externalInvoices` });
                        break;
                }
            }
        }
    }
}
